import { http } from "./http";

export const getUsers = async () => {
  const { data } = await http.get("/user");
  return data;
};

export const createUser = async (
  payload
) => {
  const { data } = await http.post(
    "/user",
    payload
  );

  return data;
};

export const updateUser = async (
  id,
  payload
) => {
  const { data } = await http.put(
    `/user/${id}`,
    payload
  );

  return data;
};